import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'A dimension defining the association between Lab Service and Labs. This is used to assign Labs to Lab Services.',
    name: 'Space Lab Assignment',
    partialId: PartialId.Standard.create('space_lab_assignment'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
